import { motion } from 'framer-motion';
import { Camera, Sparkles } from 'lucide-react';

const GalleryPage = () => {
  const images = [

    { src: '/images/bohoboxpp.jpg', category: 'Boho', title: 'Bohemian Luxe' },
    { src: '/images/boxpp.jpg', category: 'Classic', title: 'Royal Box Braids' },
    { src: '/images/borabraids.jpg', category: 'Bora Bora', title: 'Oceanic Flow' },
    { src: '/images/seneg.jpg', category: 'Twists', title: 'Velvet Senegalese' },
    { src: '/images/combraid.jpg', category: 'Mastery', title: 'Comb Precision' },
    { src: '/images/stitches.jpg', category: 'Stitches', title: 'Masterful Lines' },
    { src: '/images/bobbox.jpg', category: 'Bob', title: 'Vintage Chic' },
    { src: '/images/borabora.jpg', category: 'Bora Bora', title: 'Island Spirit' },
    { src: '/images/boxb11.jpg', category: 'Heritage', title: 'Traditional Crown' },
    { src: '/images/boxb9.jpg', category: 'Signature', title: 'Midnight Braids' },
    { src: '/images/boxb7.jpg', category: 'Classic', title: 'Ebony Elegance' },
    { src: '/images/boxb6.jpg', category: 'Heritage', title: 'Royal Roots' },
    { src: '/images/boxb5.jpg', category: 'Signature', title: 'Luxe Volume' },
    { src: '/images/boxb3.jpg', category: 'Classic', title: 'Silk finish' },
    { src: '/images/boxb1.jpg', category: 'Heritage', title: 'Heritage Weave' },
    { src: '/images/box4.jpg', category: 'Classic', title: 'Precision Box' },
    { src: '/images/bohobox5.jpg', category: 'Boho', title: 'Sunset Waves' },
    { src: '/images/bohobox3.jpg', category: 'Boho', title: 'Wild Spirit' },
    { src: '/images/bohobox2.jpg', category: 'Boho', title: 'Soft Texture' },
    { src: '/images/bohobox1.jpg', category: 'Boho', title: 'Modern Muse' },
    { src: '/images/bohob2.jpg', category: 'Boho', title: 'Couture Curl' },
    { src: '/images/bohob.jpg', category: 'Boho', title: 'Dreamer Braids' },
    { src: '/images/boho box6.jpg', category: 'Boho', title: 'Ethereal Weave' },
    { src: '/images/bstich.jpg', category: 'Stitches', title: 'Linear Art' },
    { src: '/images/stitchesc.jpg', category: 'Stitches', title: 'Geometric Prowess' },
    { src: '/images/conrows1.jpg', category: 'Cornrows', title: 'Urban Legend' },
    { src: '/images/conrows12.jpg', category: 'Cornrows', title: 'Sleek Paths' },
    { src: '/images/fppic.jpg', category: 'Masterpiece', title: 'The Face of Moyhe' },
    { src: '/images/IMG-20251024-WA0008.jpg', category: 'Knotless', title: 'Scalp Perfection' },
    { src: '/images/IMG-20251024-WA0019.jpg', category: 'Luxe', title: 'Golden Hour' },
    { src: '/images/IMG-20251024-WA0041.jpg', category: 'Twists', title: 'Silken Strands' },
    { src: '/images/IMG-20251024-WA0054.jpg', category: 'Salon', title: 'Atmosphere' },
    { src: '/images/IMG-20251024-WA0055.jpg', category: 'Details', title: 'Close Up Luxe' },
    { src: '/images/20260119_162657.jpg', category: 'New Collection', title: 'Contemporary Crown' },
    { src: '/images/20260114_151510.jpg', category: 'Modern', title: 'Sculpted Beauty' },
    { src: '/images/20250528_194623.jpg', category: 'Classic', title: 'Timeless Style' },
    { src: '/images/20240907_164820.jpg', category: 'Luxury', title: 'High Definition' },
    { src: '/images/20240413_205219~2.jpg', category: 'Couture', title: 'Runway Ready' },
    { src: '/images/20240215_140556.jpg', category: 'Art', title: 'Hair Sculpture' },
    { src: '/images/20240112_142638.jpg', category: 'Classic', title: 'The Standard' },
  ];

  return (
    <div className="pt-24 pb-32 bg-cream min-h-screen relative overflow-hidden">
      {/* Background Ambience */}
      <div className="absolute top-20 left-10 w-[400px] h-[400px] bg-rose/5 rounded-full blur-[100px] pointer-events-none animate-pulse-slow"></div>
      <div className="absolute bottom-40 right-10 w-[500px] h-[500px] bg-royal/5 rounded-full blur-[120px] pointer-events-none animate-float"></div>

      <div className="max-w-[1600px] mx-auto px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-24"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-rose/10 border border-rose/20 mb-6 font-bold text-rose text-[10px] uppercase tracking-[0.3em]">
            <Camera size={14} />
            Visual Excellence
          </div>
          <h1 className="text-6xl md:text-9xl font-serif font-bold text-dark tracking-tighter mb-8 italic">
            The <span className="text-gradient-vibrant not-italic">Luxe</span> Archive
          </h1>
          <p className="text-xl text-gray-500 max-w-2xl mx-auto font-light leading-relaxed">
            A celebration of heritage and modern style. Every image represents a journey of transformation.
          </p>
        </motion.div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-8 space-y-8">
          {images.map((img, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: index * 0.05 }}
              className="relative group break-inside-avoid rounded-[30px] overflow-hidden shadow-premium"
            >
              <motion.img
                whileHover={{ scale: 1.1 }}
                transition={{ duration: 1.5, ease: "easeOut" }}
                src={img.src}
                alt={img.title}
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-dark/90 via-dark/20 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-700 flex flex-col justify-end p-10 translate-y-4 group-hover:translate-y-0 text-white pointer-events-none">
                <span className="text-gold font-bold uppercase tracking-[0.3em] text-[9px] mb-2">{img.category}</span>
                <h3 className="text-3xl font-serif font-bold italic">{img.title}</h3>
                <div className="h-[1px] w-0 group-hover:w-full bg-gold/50 mt-4 transition-all duration-[1.5s]"></div>
              </div>
              <div className="absolute top-6 left-6 -translate-x-12 group-hover:translate-x-0 transition-transform duration-500">
                <Sparkles className="text-gold/50 w-6 h-6" />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GalleryPage;